import { render, staticRenderFns } from "./OrganismHeader.vue?vue&type=template&id=06cf4bf8"
import script from "./OrganismHeader.vue?vue&type=script&lang=ts"
export * from "./OrganismHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports